import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
    onMounted, 
    onUnmounted, 
    reactive, 
    toRefs 
  } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ElapsedTime',
  props: {
    date: { type: Date, required: true }
  },
  setup(__props) {

const prop = __props

  

  const timeTable = {
    interval: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };

  const intervals = {
    second: 1000,
    minute: 1000 * 60,
    hour: 1000 * 60 * 60,
    day: 1000 * 60 * 60 * 24
  };

  const elapsedTime = reactive(timeTable);
  const { date } = toRefs(prop);

  const update = () => {
    let diff = Math.abs(Date.now() - date.value.getTime());
      elapsedTime.days = Math.floor(diff / intervals.day);
    diff -= elapsedTime.days * intervals.day;
      elapsedTime.hours = Math.floor(diff / intervals.hour);
    diff -= elapsedTime.hours * intervals.hour;
      elapsedTime.minutes = Math.floor(diff / intervals.minute);
    diff -= elapsedTime.minutes * intervals.minute;
      elapsedTime.seconds = Math.floor(diff / intervals.second);
  }

  onMounted(() => elapsedTime.interval = setInterval(() => update(), 1000));
  onUnmounted(() => clearInterval(elapsedTime.interval));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("i", null, _toDisplayString(elapsedTime.days) + " " + _toDisplayString(elapsedTime.days == 1 ? 'days' : 'days') + " " + _toDisplayString(elapsedTime.hours) + " " + _toDisplayString(elapsedTime.hours == 1 ? 'hour' : 'hours') + " " + _toDisplayString(elapsedTime.minutes) + " " + _toDisplayString(elapsedTime.minutes == 1 ? 'minute' : 'minutes') + " ago ", 1)
  ]))
}
}

})